import { render } from "./BlogPostCard.vue?vue&type=template&id=50325acb"
import script from "./BlogPostCard.vue?vue&type=script&lang=js"
export * from "./BlogPostCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__